import { render, staticRenderFns } from "./budget-fp.vue?vue&type=template&id=2503aaab"
import script from "./budget-fp.vue?vue&type=script&lang=js"
export * from "./budget-fp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports